(function () {
  'use strict';

  const root = document.currentScript;
  const componentSelector = '[data-jm-component="opinew-keyboard-compat"]';

  if (!root || !root.matches(componentSelector)) return;
  if (!document.body || !document.body.classList.contains('template-product')) return;
  if (document.querySelector(`${componentSelector}[data-jm-initialized="true"]`)) return;

  root.setAttribute('data-jm-initialized', 'true');

  const opinewRootSelector = '#opinew_product_plugin_app, #opinew-reviews-product-page-code';
  const opinewModalSelector = '.opw-generic-modal';

  function isVisibleOpenModal(modal) {
    if (modal.closest('[hidden], [inert], [aria-hidden="true"]')) return false;

    const style = window.getComputedStyle(modal);
    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      style.visibility === 'collapse'
    ) {
      return false;
    }

    const rect = modal.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function hasVisibleOpenOpinewModal(modalShells) {
    return Array.prototype.some.call(modalShells, isVisibleOpenModal);
  }

  document.body.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    if (!document.querySelector(opinewRootSelector)) return;

    const modalShells = document.querySelectorAll(opinewModalSelector);

    // Fail open if Opinew changes its known modal-shell contract.
    if (!modalShells.length || hasVisibleOpenOpinewModal(modalShells)) return;

    // Local controls have already received the event. Stop only the later
    // closed-modal Opinew global handler without canceling native traversal.
    event.stopPropagation();
  });
})();
